import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// Vue-video-player 配置（Vue2 兼容版本）
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'

Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(VueVideoPlayer)

// ========== 前端部署后 chunk 加载失败兜底 ==========
// 现象：增量部署后，浏览器缓存了旧 index.html，点击路由懒加载时会请求
// 一个已不存在的旧 hash chunk（如 860.xxx.css），报 ChunkLoadError，
// 导致按钮点不动。这里捕获该错误，自动刷新一次页面让浏览器重新拉取
// 最新 index.html（前提是 nginx 对 index.html 配置了 no-cache）。
let chunkReloaded = false
router.onError((error) => {
  const isChunkError = error && (
    /Loading chunk [\d]+ failed/i.test(error.message) ||
    /Loading CSS chunk [\d]+ failed/i.test(error.message)
  )
  if (isChunkError && !chunkReloaded) {
    chunkReloaded = true
    // 保留当前路由，刷新后回到原页面
    window.location.reload()
  }
})

const testUrl = 'http://localhost:8000';

// const web = 'http://119.91.150.183/api';
const web = 'https://qianyan-edu.com/api';

// const trueUrl = testUrl;
const trueUrl = web;

axios.defaults.baseURL = trueUrl;

export function apiUrl(){
  return web.slice(0, -4); // 图片的前缀，要访问服务器的图片
}

Vue.prototype.$axios = axios;
Vue.prototype.$apiUrl = trueUrl;

// 请求拦截器，添加token
axios.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
}, error => {
  return Promise.reject(error)
})

// 响应拦截器
// 说明：并发请求可能同时收到 401，若不加去重会重复 router.push('/login')，
// 触发 vue-router 的 "Navigation cancelled ... with a new navigation" 报错刷屏。
let redirectingToLogin = false
axios.interceptors.response.use(response => {
  return response
}, error => {
  if (error.response && error.response.status === 401) {
    // 非关键请求（如只用于展示的课程详情）401 时不强制登出，避免误伤
    if (error.config && error.config.skipAuthRedirect) {
      return Promise.reject(error)
    }
    if (!redirectingToLogin) {
      redirectingToLogin = true
      store.commit('LOGOUT')
      const cur = router.currentRoute
      // 用 path 判断（登录路由不一定有 name）
      if (cur && cur.path !== '/login') {
        // 带上 redirect，登录后能回到原来页面（比如支付结果页）
        router.push({ path: '/login', query: { redirect: cur.fullPath } })
          .catch(() => {})
          .finally(() => { redirectingToLogin = false })
      } else {
        redirectingToLogin = false
      }
    }
  }
  return Promise.reject(error)
})

// 全局路由守卫
router.beforeEach((to, from, next) => {
  // ★ 新增：所有 /science-extension 开头的路由直接放行
  if (to.path.startsWith('/science-extension')) {
    next();
    return;
  }

  const isAuthenticated = store.state.user.isAuthenticated
  
  // 页面标题设置
  if (to.meta.title) {
    document.title = `${to.meta.title} - 在线学习平台`
  } else {
    document.title = '赣州市前沿科教设备有限公司'
  }
  
  // 需要登录的页面检查
  if (to.meta.requiresAuth && !isAuthenticated) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else if (to.path === '/login' && isAuthenticated) {
    next('/')
  } else {
    next()
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')